module.exports = __webpack_public_path__ + "img/loot-check.6e4272bc.svg";